import { gqlTalentUnionEnum as TALENT_UNION, gqlGenderIdentityEnum as GENDER_IDENTITY } from '@minecraft.graphql-types';

import { FiltersNameEnum } from '../types';

export const TALENT_UNION_NON_MEMBER = 'NON_MEMBER';

export const NOT_YET_SENT = 'NOT_YET_SENT';

export const filtersKeySuffix = 'Filters';

export const WORKSHEET_FILTERS_SESSION_STORAGE_KEY = `REPSWorksheet${filtersKeySuffix}`;

export const WORKSHEET_GROUPING_SESSION_STORAGE_KEY = `REPSWorksheetGroups`;

export const WORKSHEET_ARGUMENTS_SESSION_STORAGE_KEY = 'cdWorksheetArguments';

export const AGE_LIMIT = 120;

export const CD_AGE_LIMIT = 17;

export const dependentFilters = {
  [FiltersNameEnum.skills]: [FiltersNameEnum.skillLevels],
};

export const emptyOption = {
  value: '',
  label: '',
};

export const initialRadioButtonSkillLevelValue = {
  value: [],
  label: '',
};

export const sagAftraOption = {
  value: TALENT_UNION.SAG_AFTRA,
  label: 'SAG-AFTRA',
};

export const sagAftraChildrenExclusion = [TALENT_UNION.ELIGIBLE, TALENT_UNION.FICORE];

export const defaultExcludeFilters = [
  FiltersNameEnum.autofillByRoleCriteria,
  FiltersNameEnum.nonUnion,
  FiltersNameEnum.sizesCategory,
  FiltersNameEnum.sizesChildrenCategory,
];

export const defaultExcludeFilterValues = {
  [FiltersNameEnum.unionStatus]: [sagAftraOption.value],
  [FiltersNameEnum.excludeUnionStatus]: [sagAftraOption.value],
};

export const genderIdentityWhiteList = [GENDER_IDENTITY.TRANS, GENDER_IDENTITY.NON_BINARY];
